import React from "react";

import { STEP_KINDS } from "./stepKinds";

/**
 * Choix du type au moment de CRÉER une étape.
 *
 * POURQUOI ICI, ET PAS DANS UN ASSISTANT. Découper l'édition en un parcours
 * obligatoire Type → Position → Carte → Contenu est confortable la première
 * fois et pénible les vingt suivantes, quand on revient corriger une phrase.
 * Le découpage reste (ce sont les onglets de l'éditeur), mais la SÉQUENCE ne
 * s'impose qu'une fois : à la création, où l'auteur n'a de toute façon rien
 * d'autre à faire que choisir la forme de son écran.
 *
 * Le type reste modifiable ensuite depuis l'onglet ①, sans perdre le cadrage.
 */
export default function StepTypePicker({ onPick, onCancel }) {
  return (
    <div className="builder-picker-overlay" onClick={onCancel}>
      <div className="step-typepicker" onClick={(e) => e.stopPropagation()}>
        <div className="builder-picker-header">
          <h3>Quelle forme d'étape ?</h3>
          <button onClick={onCancel}>✕</button>
        </div>
        <p className="step-editor-section-hint" style={{ padding: "0 20px" }}>
          Ce que le participant verra à côté de la carte. Le cadrage et les couches se règlent
          ensuite, et le type reste modifiable.
        </p>
        <div className="step-picker-grid step-picker-grid--wide" style={{ padding: 20 }}>
          {STEP_KINDS.map((kind) => (
            <button
              key={kind.id}
              type="button"
              className="step-picker-card"
              onClick={() => onPick(kind.id)}
            >
              {kind.sketch}
              <span className="step-picker-label">{kind.label}</span>
              <span className="step-picker-hint">{kind.hint}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
